import { useSearchParams } from 'react-router-dom';
import LoginPage from './LoginPage';
import MaintenancePage from './MaintenancePage';
import ForgotPasswordPage from './ForgotPasswordPage';
import RegisterPage from './RegisterPage';
import { isFeatureEnabled } from '../config/featureFlags';
import { useNoIndexPageMeta } from '../marketing/useMarketingPageMeta';

export default function GuestEntry() {
  useNoIndexPageMeta('VisiMe — Sign in', '/');
  const [searchParams] = useSearchParams();
  const maintenanceModeEnabled = isFeatureEnabled('webGuestMaintenanceMode');
  if (searchParams.get('forgot') === '1') {
    return <ForgotPasswordPage />;
  }
  if (searchParams.get('register') === '1') {
    return <RegisterPage />;
  }
  if (searchParams.get('login') === '1') {
    return <LoginPage />;
  }
  return maintenanceModeEnabled ? <MaintenancePage /> : <LoginPage />;
}
